export function getRatingImageForNumber (number) {
  return `https://www.tripadvisor.com/img/cdsi/img2/ratings/traveler/${number.toFixed(1)}-20402-5.svg`
}
